// MOCK DATA ONLY — backend integration will be added later (after your approval)

export const featuredGames = [
  {
    id: "lol",
    title: "League of Legends",
    tagline: "Become a legend. Choose your champion and dominate 5v5.",
    cta: "Pre-order",
    kind: "Featured",
    rating: 4.8,
    cover:
      "https://images.unsplash.com/photo-1637166185518-058f5896a2e9?auto=format&fit=crop&w=1600&q=80",
    accent: "teal",
    chips: ["MOBA", "Competitive", "Free-to-play"],
  },
  {
    id: "neon",
    title: "Neon District",
    tagline: "A city that never sleeps. Neither should your reflexes.",
    cta: "Watch trailer",
    kind: "New",
    rating: 4.6,
    cover:
      "https://images.unsplash.com/photo-1519608487953-e999c86e7455?auto=format&fit=crop&w=1600&q=80",
    accent: "blue",
    chips: ["Action", "Cyberpunk", "Single-player"],
  },
  {
    id: "skyline",
    title: "Skyline Protocol",
    tagline: "High altitude missions and impossible choices.",
    cta: "Pre-order",
    kind: "Featured",
    rating: 4.7,
    cover:
      "https://images.unsplash.com/photo-1573767291321-c0af2eaf5266?auto=format&fit=crop&w=1600&q=80",
    accent: "mint",
    chips: ["Strategy", "Sci-fi", "Tactical"],
  },
  {
    id: "mist",
    title: "Castle of Mist",
    tagline: "Explore a kingdom swallowed by fog and forgotten magic.",
    cta: "Explore",
    kind: "Adventure",
    rating: 4.5,
    cover:
      "https://images.unsplash.com/photo-1514539079130-25950c84af65?auto=format&fit=crop&w=1600&q=80",
    accent: "amber",
    chips: ["RPG", "Fantasy", "Story"],
  },
]

export const discountGames = [
  {
    id: "gow",
    title: "God of War",
    kind: "Basic game",
    genre: "Action",
    discountPct: 75,
    originalPrice: 59.99,
    salePrice: 9.99,
    cover:
      "https://images.unsplash.com/photo-1550100136-e092101726f4?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "cyber",
    title: "Cyber City Runner",
    kind: "Basic game",
    genre: "RPG",
    discountPct: 50,
    originalPrice: 29.99,
    salePrice: 14.99,
    cover:
      "https://images.pexels.com/photos/1202849/pexels-photo-1202849.jpeg?auto=compress&cs=tinysrgb&w=900",
  },
  {
    id: "control",
    title: "Control",
    kind: "Basic game",
    genre: "Shooter",
    discountPct: 75,
    originalPrice: 59.99,
    salePrice: 9.99,
    cover:
      "https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "legacy",
    title: "Hogwarts Legacy",
    kind: "Basic game",
    genre: "Adventure",
    discountPct: 25,
    originalPrice: 59.99,
    salePrice: 44.99,
    cover:
      "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "tunnel",
    title: "The Tunnel",
    kind: "Basic game",
    genre: "Horror",
    discountPct: 60,
    originalPrice: 39.99,
    salePrice: 15.99,
    cover:
      "https://images.pexels.com/photos/325185/pexels-photo-325185.jpeg?auto=compress&cs=tinysrgb&w=900",
  },
  {
    id: "ocean",
    title: "Abyssal Drift",
    kind: "Basic game",
    genre: "Indie",
    discountPct: 40,
    originalPrice: 24.99,
    salePrice: 14.99,
    cover:
      "https://images.pexels.com/photos/326055/pexels-photo-326055.jpeg?auto=compress&cs=tinysrgb&w=900",
  },
]

export const fastLaunch = [
  {
    id: "minecraft",
    title: "Minecraft",
    cover:
      "https://images.unsplash.com/photo-1659167911918-03fe74c396f8?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "rdr2",
    title: "Red Dead Redemption 2",
    cover:
      "https://images.unsplash.com/photo-1514539079130-25950c84af65?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "farcry",
    title: "Far Cry 6",
    cover:
      "https://images.unsplash.com/photo-1519608487953-e999c86e7455?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "mafia",
    title: "Mafia: Definitive Edition",
    cover:
      "https://images.unsplash.com/photo-1550100136-e092101726f4?auto=format&fit=crop&w=400&q=80",
  },
]

export const categories = [
  {
    id: "action",
    title: "Action",
    subtitle: "Fast reflexes & cinematic fights",
  },
  {
    id: "rpg",
    title: "RPG",
    subtitle: "Build characters and choices",
  },
  {
    id: "strategy",
    title: "Strategy",
    subtitle: "Plan. Counter. Win.",
  },
  {
    id: "indie",
    title: "Indie",
    subtitle: "Fresh ideas & bold art",
  },
  {
    id: "sim",
    title: "Simulation",
    subtitle: "Relax and optimize",
  },
  {
    id: "horror",
    title: "Horror",
    subtitle: "Atmosphere and tension",
  },
]
